import { Component } from 'react';
import CheckboxGroup from '../CheckboxGroup';
import { validator } from 'Helpers/validator';
import validation from 'Helpers/Validation';
import LoadingOverlay from 'react-loading-overlay';
import { ModuleActions } from 'Constants/Modules.constants';

class EditManageAdminRoles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      module: {},
      roleName: '',
      childrender: false,
      editErrorElement: '',
      allowerModulesError: '',
      allowedModulesErrorMessage: 'Please grant access to at least one role.',
    };
    this.validator = validator.getInstance();
  }

  componentDidMount() {
    const { roleName, adminRoles, id, allowedModules } = this.props;

    const moduleFilter = adminRoles
      .filter((x) => x.id === id)
      .map((val) => {
        return val.allowedModules !== ''
          ? JSON.parse(val.allowedModules)
          : null;
      })
      .filter(Boolean);
      let module = { ...moduleFilter[ 0 ] };
      const afterUpdate = {};
      if(allowedModules){
        for (const property in allowedModules) {
          const defaultModule = allowedModules[ property ] || {};
          const roleModule = module[ property ] || {}; 
          afterUpdate[ property ] = { ...defaultModule, ...roleModule };
        }
      }
    this.setState({
      roleName,
      module: afterUpdate,
      childrender: true,
    });
  }

  /**
   * @method validation
   * @summary validate the inputs based on validation rules
   * @param {event} event - React onBlur event
   * @return {none} undefined
   */

  validation = (e) => {
    validation(e, 'editroleform');
  };

  closeEditRoles = () => {
    this.props.closeEditRoles();
  };

  onCheckboxGroupChange = (checkboxGroupkey, checkboxes) => {
    this.setState((prevState) => ({
      ...prevState,
      module: {
        ...prevState.module,
        [ checkboxGroupkey ]: checkboxes,
      },
    }));
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [ name ]: value });
  };

  createcheckBoxGroup = () => {
    var checkboxGroupArray = [];
    const { editClass } = this.props;

    for (const property in this.state.module) {
      const cb = this.state.module[ property ];
      const isChecked = cb && Object.keys(cb).some(key => cb[ key ]);
      cb[ ModuleActions.view ] = isChecked;
      checkboxGroupArray.push(
        <CheckboxGroup
          checkboxes={ this.state.module[ property ] }
          checkboxGroupkey={ property }
          parentClass={ editClass }
          key={ property }
          onCheckboxGroupChange={ this.onCheckboxGroupChange }
        />
      );
    }
    return checkboxGroupArray;
  };

  isOneChecked = () => {
    const radio = document.getElementsByTagName('input');
    for (let i = 0; i < radio.length; i++) {
      if (radio[ i ].type == 'checkbox' && radio[ i ].checked) {
        return true
      } 
    }
    return false
  }

   handleSubmit = (event) => {
    event.preventDefault();
    const { id } = event.target;
    this.setState({
      allowerModulesError: this.isOneChecked() ? '' : this.state.allowedModulesErrorMessage
    }, () => {
      if (id && !this.validator.checkBeforeSubmit(id) && this.state.allowerModulesError === '') {
        const { id } = this.props;
        const { roleName, module } = this.state;
        const updateData = { roleName, module, id };
        this.props.updateAdminRoles(updateData);
      }
    })
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.error !== this.props.error) {
      if (this.props.error !== true && this.props.errorElement === '') {
        this.closeEditRoles();
      }
    }
    if (prevProps.editErrorElement !== this.props.editErrorElement) {
      this.setState({ editErrorElement: this.props.editErrorElement });
    }
  }

  render() {
    const { roleName, childrender, editErrorElement, allowerModulesError } = this.state;
    const { title, formLoading } = this.props;
    return (
      <>
        <div className='addadmin' id={ this.props.formId }>
          <div className='overlay' onClick={ this.closeEditRoles }></div>
          <div className='addadminroles'>
            <LoadingOverlay
              active={ formLoading }
              spinner
              styles={ {
                wrapper: {
                  width: '100%',
                  textAlign: '-webkit-center',
                },
              } }
              text='Please wait...'
            ></LoadingOverlay>
            <div className='head'>
              <h2> {title}</h2>
            </div>
            <form
              id='editroleform'
              autoComplete='off'
              onSubmit={ this.handleSubmit }
            >
              <div className='ctInputField'>
                <label>
                  Role<sup>*</sup>
                </label>
                <input
                  id='roleName'
                  onChange={ this.handleChange }
                  value={ roleName }
                  type='text'
                  name='roleName'
                  data-length={ 50 }
                  onBlur={ this.validation }
                  data-validation={ [ 'requiredfield,maxlength' ] }
                  data-error='Enter valid role name'
                  placeholder='Enter role here!'
                />
                {editErrorElement !== '' && (
                  <span className='errorElement'>{editErrorElement}</span>
                )}
              </div>
              <div className='allowedmodules'>
                <h3>Allowed Modules</h3>
                { allowerModulesError && <span id="allowedModules-requiredfield" className="error">{ allowerModulesError }</span> }
                <div className='allroles'>
                  {childrender && this.createcheckBoxGroup()}
                </div>
              </div>

              {title === 'Edit Roles' && (
                <div className='buttons'>
                  <div>
                    <button
                      type='reset'
                      onClick={ this.closeEditRoles }
                      className='btn btn_outline'
                    >
                      Cancel
                    </button>
                    <button type='submit' className='btn btn_primary'>
                      Update
                    </button>
                  </div>
                </div>
              )}
              {title === 'View Roles' && (
                <div className='buttons'>
                  <div>
                    <button
                      type='reset'
                      onClick={ this.closeEditRoles }
                      className='btn btn_outline'
                    >
                      Cancel
                    </button>
                    <button
                      onClick={ this.props.changeEditView }
                      className='btn btn_primary'
                    >
                      Edit
                    </button>
                  </div>
                </div>
              )}
            </form>
          </div>
        </div>
      </>
    );
  }
}

export default EditManageAdminRoles;
